module.exports = __webpack_public_path__ + "static/media/15UN-Habitat5.b43f4f7d.jpg";